
import { defineComponent } from "vue";
import Call from "../components/landingpageGTop/Call.vue";
import Introduction from "../components/landingpageGTop/Introduction.vue";
import Mission from "../components/landingpageGTop/Mission.vue";
import ResetPassword from "../components/landingpageGTop/ResetPassword.vue";
import { useRouter } from "vue-router";
import FirstLogin from "../components/landingpageGTop/FirstLogin.vue";
import { enableBodyOverflow } from "../components/mixins";
import ModalTerm from "../components/landingpageGTop/ModalTerm.vue";
import Supporters from "../components/landingpageGTop/Supporters.vue";
import FooterGTop from "../components/landingpageGTop/Footer.vue";

export default defineComponent({
  components: {
    FooterGTop,
    Supporters,
    ModalTerm,
    Call,
    Introduction,
    Mission,
    ResetPassword,
    FirstLogin
  },

  setup() {
    /** Instance of a router. */
    const router = useRouter();

    /** Closes the currently open modal by redirecting user to the home page. */
    const closeModal = async () => {
      await router.push({ name: "home" });
      enableBodyOverflow();
    };

    return {
      closeModal
    };
  }
});
